require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-three-battle-tested-ways-to-install-postgresql.json") })
        }
      }, "path---blog-three-battle-tested-ways-to-install-postgresql");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-three-battle-tested-ways-to-install-postgresql!./.cache/json/blog-three-battle-tested-ways-to-install-postgresql.json
// module id = 1095
// module chunks = 231608221292675